module.exports = __webpack_public_path__ + "static/media/mouse.69cdd89c.png";